import { AxiosInstance, AxiosResponse } from "axios";
import {
  CardConsultDataResponseDTO,
  CardConsultProfileProductsResponseDTO
} from "../entities/Card";

const resourcePrefix = "/Cartao";

export class CardResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async consultProfile(
    cpf: string
  ): Promise<AxiosResponse<CardConsultProfileProductsResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarPerfil?strCpf=${cpf}`
    );
  }
  async consultProfileWithCardNumber(
    cardNumber: string
  ): Promise<AxiosResponse<CardConsultProfileProductsResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarPerfil?strPlastico=${cardNumber}`
    );
  }

  async consultData(
    strProduto: string,
    cardId: number
  ): Promise<AxiosResponse<CardConsultDataResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarDados?strProduto=${strProduto.toString()}&lngCartao=${cardId}`
    );
  }

  async validateCardPassword(
    strPlastico: string,
    strSenha: string
  ): Promise<AxiosResponse<boolean>> {
    return this.apiProvider.post(`${resourcePrefix}/ValidarSenhaPlastico`, {
      strPlastico,
      strSenha
    });
  }
}
